import React, { memo } from 'react';

const PrimaryFieldFormatter = (props) => {
  return (
    <div className="primaryCell" title={props.value}>
      {props.value}
    </div>
  );
};

export default memo(PrimaryFieldFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
